/* beautiful-react-hooks version: 0.35.0 */
import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';
import useMouseEvents from './useMouseEvents.js';

var createStateObject = function createStateObject(event) {
  return {
    clientX: event.clientX,
    clientY: event.clientY,
    screenX: event.screenX,
    screenY: event.screenY
  };
};

var useMouseState = function useMouseState() {
  var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _useState = useState({
    clientX: 0,
    clientY: 0,
    screenX: 0,
    screenY: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useMouseEvents = useMouseEvents(ref),
      onMouseMove = _useMouseEvents.onMouseMove;

  onMouseMove(function (event) {
    var nextState = createStateObject(event);
    setState(nextState);
  });
  return state;
};

export default useMouseState;
